import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark, faCircleCheck } from "@fortawesome/free-solid-svg-icons";

const Section6 = ({url}) => {
  return (

  <section className="home-section-6">
     <div className="container">
    
            {/* Heading */}
            <div className="section-header text-center">
              <h2>
                {/* Traditional vs <span>Intelihire Comparison</span> <br/> */}
                Head-to-Head Comparison
              </h2>
            </div>
    
            <div className="row comparison-row">
    
              {/* LEFT CARD */}
              <div className="col-lg-6 col-xl-5 overflow-hidden">
                <div className="comparison-card left-card">
    
                  <div className="card-header">
                    <FontAwesomeIcon icon={faCircleXmark} className="icon red" />
                    <h5>Traditional Hiring</h5>
                  </div>
    
                  <ul>
                    <li>Weeks of back-and-forth coordinating interview schedules.</li>
                    <li>Inconsistent screening based on gut feeling and bias.</li>
                    <li>Scattered tools across email, spreadsheets, and calendars.</li>
                    <li>Limited visibility into candidate quality until late stages.</li>
                    <li>Generic process that doesn't reflect your brand.</li>
                  </ul>
    
                </div>
              </div>
    
              {/* RIGHT CARD */}
              <div className="col-lg-6 col-xl-5 overflow-hidden">
                <div className="comparison-card right-card">
    
                  <div className="card-header">
                    <FontAwesomeIcon icon={faCircleCheck} className="icon green" />
                    <h5>With Intelihire</h5>
                  </div>
    
                  <ul>
                    <li>Minutes to shortlist top candidates with AI ranking.</li>
                    <li>Automatic scheduling synced with Google Calendar.</li>
                    <li>Data-driven evaluation with predictive matching scores.</li>
                    <li>One unified platform for your entire hiring workflow.</li>
                    <li>Instant insights on every applicant from day one.</li>
                    <li>Branded experience across web and mobile</li>
                  </ul>
    
                </div>
              </div>
    
            </div>
    
          </div>
    </section>
  );
};

export default Section6;
